import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import api from "../lib/api";

export default function ForgotPassword() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const inFlight = useRef(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (inFlight.current) return;
    inFlight.current = true; setLoading(true); setMsg("");
    try {
      await api.post("/auth/forgot-password", { email });
      setMsg(lang === "de" ? "Falls ein berechtigtes Konto existiert, wird eine E-Mail zum Zurücksetzen angefordert." : "If an eligible account exists, a password reset email is requested.");
    } catch { setMsg(lang === "de" ? "Die Anfrage ist gerade nicht möglich. Bitte versuche es später erneut." : "The request is currently unavailable. Please try again later."); }
    finally { inFlight.current = false; setLoading(false); }
  };

  return (
    <Shell title={t("forgotTitle")} sub={t("forgotSub")}>
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <input data-testid="forgot-email" className="pc-input" type="email" placeholder={t("email")}
          value={email} onChange={(e) => setEmail(e.target.value)} required />
        <button data-testid="forgot-submit" className="pc-btn pc-btn-primary w-full" disabled={loading}>
          {loading ? "…" : t("sendResetLink")}
        </button>
      </form>
      {msg && <p data-testid="forgot-msg" className="mt-4 text-sm" style={{ color: "var(--pc-muted)" }}>{msg}</p>}
      <button onClick={() => nav("/login")} className="mt-6 text-sm" style={{ color: "var(--pc-cyan)", background: "none", border: "none", cursor: "pointer" }}>{t("backToLogin")}</button>
    </Shell>
  );
}

export function Shell({ title, sub, children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--pc-black)" }}>
      <div className="flex justify-end px-6 py-6 safe-top"><LanguageSwitcher /></div>
      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <div className="w-full max-w-md pc-fade">
          <h1 className="text-3xl font-display font-bold">{title}</h1>
          {sub && <p className="mt-2 mb-6 text-sm" style={{ color: "var(--pc-muted)" }}>{sub}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
